export default __webpack_public_path__ + "static/media/person-icon.95be3263.png";